// Los rechazos de la verificación y del paso de cliente tal como los lee el supervisor. La API ya contesta
// en español, pero nombra cada campo por su clave del contrato ('cp_domicilio', «cp_domicilio»): aquí se
// nombra por su etiqueta en la pantalla, y el resto del motivo se queda como lo dice la API.
import { CAMPOS } from './campos';

// La etiqueta de un campo en la pantalla, o su clave si la pantalla no lo conoce.
function etiqueta(clave: string): string {
  return CAMPOS.find((c) => c.clave === clave)?.etiqueta ?? clave;
}

// Cada motivo conocido: cómo lo dice la API (ValidadorVerificacion y FeriasCasosController) y el texto
// que muestra la pantalla.
const MOTIVOS: [RegExp, (m: RegExpExecArray) => string][] = [
  [/^Falta el campo '([a-z0-9_]+)'\.$/, (m) => `Falta el campo «${etiqueta(m[1])}».`],
  [/^Campo 'fecha': una fecha AAAA-MM-DD, o vacía\.$/, () => 'La fecha debe escribirse como AAAA-MM-DD (por ejemplo, 2026-11-04) o quedar vacía.'],
  [/^Campo 'aviso': como mucho (\d+) caracteres\.$/, (m) => `El Aviso admite como máximo ${m[1]} caracteres.`],
  [/^Campo '([a-z0-9_]+)': .+$/, (m) => `El campo «${etiqueta(m[1])}» tiene un valor que la ficha no admite.`],
  [
    /^La lectura \d+ no es una lectura correcta del caso (\d+)\.$/,
    (m) => `La lectura mostrada ya no es válida para la ficha #${m[1]}. Vuelva a abrir la ficha.`,
  ],
  [/^El caso (\d+) no existe o está eliminado\.$/, (m) => `La ficha #${m[1]} no existe o se ha eliminado.`],
  // Los del paso de cliente (FeriasClienteController).
  [/^El caso (\d+) todavía no está verificado\.$/, (m) => `La ficha #${m[1]} aún no está verificada: confirme su lectura antes de buscar el cliente.`],
  [
    /^Gescom no está disponible en esta base de datos\.$/,
    () => 'Gescom no está disponible en esta base de datos. El paso de cliente necesita la base de pruebas de Gescom.',
  ],
];

// Un campo nombrado por su clave entre comillas angulares («cp_domicilio»), como lo escriben los
// rechazos del paso de cliente (ActualizarCliente y ValidadorValoresCliente).
const CLAVE_ENTRE_COMILLAS = /«([a-z0-9_]+)»/g;

/** El motivo de la API en el texto de la pantalla, si es uno conocido; si no, tal como llegó. */
export function motivoEnPantalla(motivo: string): string {
  for (const [patron, texto] of MOTIVOS) {
    const encontrado = patron.exec(motivo);
    if (encontrado) {
      return texto(encontrado);
    }
  }
  return motivo.replace(CLAVE_ENTRE_COMILLAS, (_, clave: string) => `«${etiqueta(clave)}»`);
}
